/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type BatteryBadge_DisplayFragment = { __typename: 'Display', id: string, battery?: { __typename: 'BatteryState', reportedAt?: any | null, reported: { __typename: 'Battery', present: boolean, level: number, powerSource: string, powerManagement: string } } | null };

export const BatteryBadge_DisplayFragmentDoc = gql`
    fragment BatteryBadge_display on Display {
  id
  battery {
    reportedAt
    reported {
      present
      level
      powerSource
      powerManagement
    }
  }
}
    `;